<template>
    <section class="hot-panel-multi">
        <section-title :title="title" />
        <div
            v-html="content"
            @click="clickHandle"
            class="hot-panel-multi-content"
        />
    </section>
</template>

<script>
import SectionTitle from './sectionTitle';

export default {
    name: 'HotPanelMulti',
    components: {
        SectionTitle,
    },
    props: {
        title: {
            type: String,
            default: '',
        },
        content: {
            type: String,
            default: '',
        },
    },
    methods: {
        clickHandle($event) {
            const link = $event.target.closest('a');
            if (link && link.href) {
                $event.preventDefault();
                window.open(link.href);
            }
        },
    },
};
</script>

<style lang="less" scoped>
.hot-panel-multi-content {
    word-break: break-all;
    font-size: 12px;
    line-height: 20px;

    ::v-deep {
        ul {
            list-style-type: disc;
        }

        ol {
            list-style-type: decimal;
        }

        ul, ol {
            margin: 10px 0 10px 20px;
        }

        h1, h2, h3, h4, h5, h6 {
            font-weight: bold;
            margin: 10px 0;
            line-height: 1.5;
        }

        h1 {
            font-size: 2em;
        }

        h2 {
            font-size: 1.5em;
        }

        h3 {
            font-size: 1.17em;
        }

        h4 {
            font-size: 1em;
        }

        h5 {
            font-size: 0.83em;
        }

        h6 {
            font-size: 0.67em;
        }
    }
}
</style>
